import { PreviewPageEnv } from "../constants/PreviewPageEnv";
import { IConfig } from "./IConfig";
import configLabs from "./configLabs";
import configStaging from "./configStaging";
import configProd from "./configProd";

export const getConfig = (env: PreviewPageEnv): IConfig => {
  switch (env) {
    case PreviewPageEnv.Labs:
      return configLabs;
    case PreviewPageEnv.Staging:
      return configStaging;
    default:
      return configProd;
  }
};
